<template>
  <button
    class="
      link/focus
      "
      type="button"
      :data-gtm="gtm"
      @click.prevent="$emit('sort', $event.target.value)"
    >
    <div
      class="
        layout/flex
        layout/width:100%
        layout/justify:center
        layout/align:center
        layout/height:baseline:2
        $typography/baseline:solid
        $typography/size:large
        "
      style="
        pointer-events: none;
      "
      :class="{
        '$color/background:black $color/background:alpha:100% color/background': highlighted
      }"
      >
      <div
        class="
          layout/padding:cap
          $typography/size:medium
        "
        style="
          pointer-events: none;
        "
        >
        <p
          class="
            typography
          "
          style="
            pointer-events: none;
          "
          :class="{
            '$color/gray:eee': highlighted
          }"
          v-html="label"
        />
      </div>
    </div>
  </button>
</template>

<script>
  export default {
    props: {
      highlighted: { type: Boolean, required: true },
      label: { type: String, required: true },
      gtm: { type: String, required: true },
    },
  };
</script>
